module.exports = __webpack_public_path__ + "img/03.452b0ccc.png";